module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-right": "0px",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    attrs: {
      "for": "pagesize"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('select', {
    ref: "recordPerPage",
    staticClass: "form-control",
    attrs: {
      "id": "pagesize"
    },
    on: {
      "change": _vm.changePageSize
    }
  }, [(_vm.inquiryParam.pageSize == 5) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("5")]) : _c('option', [_vm._v("5")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 10) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("10")]) : _c('option', [_vm._v("10")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 20) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("20")]) : _c('option', [_vm._v("20")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 50) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("50")]) : _c('option', [_vm._v("50")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 100) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("100")]) : _c('option', [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-md-9 has-feedback"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by POS name"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onSearch($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-search form-control-feedback"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "o_kanban_view o_kanban_dashboard o_pos_kanban o_kanban_ungrouped"
  }, _vm._l((_vm.listData), function(row, i) {
    return _c('div', {
      key: i,
      staticClass: "o_kanban_record"
    }, [_c('div', {
      staticClass: "o_kanban_card_header"
    }, [_c('div', {
      staticClass: "o_kanban_card_header_title mb16"
    }, [_c('div', {
      staticClass: "o_primary"
    }, [_vm._v("\n              " + _vm._s(row.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "o_secondary mt16"
    }, [_vm._v("\n              " + _vm._s(row.usedByCashierId == 0 ? 'Unused' : row.usedByCashierName) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "container o_kanban_card_content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 o_kanban_primary_left"
    }, [(row.status == _vm.SESSION_NEW) ? _c('button', {
      staticClass: "btn btn-primary oe_kanban_action oe_kanban_action_button",
      on: {
        "click": function($event) {
          _vm.onNewSession(row)
        }
      }
    }, [_vm._v("New Session")]) : _vm._e(), _vm._v(" "), (row.status == _vm.SESSION_INPROGRESS) ? _c('button', {
      staticClass: "btn btn-primary oe_kanban_action oe_kanban_action_button",
      on: {
        "click": function($event) {
          _vm.onResume(row)
        }
      }
    }, [_vm._v("Resume")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 o_kanban_primary_right"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "o_dropdown_kanban dropdown"
    }, [_vm._m(0, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu",
        "aria-labelledby": "dLabel"
      }
    }, [_c('li', [_c('a', {
      staticClass: " oe_kanban_action oe_kanban_action_a",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.gotoSession(row)
        }
      }
    }, [_vm._v("Session")])]), _vm._v(" "), _c('li', [_c('a', {
      staticClass: " oe_kanban_action oe_kanban_action_a",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.gotoPOSSetting(row)
        }
      }
    }, [_vm._v("Setting")])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row pull-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind",
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber - 1)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("\n              Page\n          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiryParam.CurrentPageNumber),
      expression: "inquiryParam.CurrentPageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "margin-left": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "id": "CurrentPage"
    },
    domProps: {
      "value": (_vm.inquiryParam.CurrentPageNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.gotoPage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inquiryParam, "CurrentPageNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "TotalPageText"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.totalPages) + "                \n          ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-right-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber + 1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-fastforward",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.totalPages)
      }
    }
  })])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle btn",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "aria-expanded": "true"
    }
  }, [_c('span', {
    staticClass: "icon ion-more",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-761719d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/POSDashboard.vue
// module id = 756
// module chunks = 1